import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import { Container, Row, Col } from 'reactstrap'
import { RepsQuery } from '../Functions/querys'
import { AllCarLocations, AllRideSharingPartners, AllAgreementTypes, AllBrokers } from './ReservationQueries'
import ReservationsListHeader from '../CA/ReservationsListHeader'
import ReservationsList from '../CA/ReservationsList'
import './ReservationsListContainer.css'
import { buildPresets } from '../Filters/presetFilters'

import withApolloClient from '../withApolloClient'

export const PRESETS = buildPresets([
    { fieldName: "status", filterType: "equal", filterValues: "Open", editable: false, visible: false },
    { fieldName: "car", filterType: "is_null", filterValues: null, editable: false, visible: false },
])

class InactiveReservationsListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filterValues: {
                orderBy: ["-driver__in_office", "date_added"],
            },
            selectedDrivers: [],
            refetchReservations: false,
            presets: PRESETS,
            defaultPresets: PRESETS,
        }
    }

    setPresets = (presets) => this.setState({ presets })
    updateOrder = (string) => {
        let order = [...this.state.filterValues.orderBy]
        if (!order.includes(string) && !order.includes("-" + string)) {
            order = [order.find(item => item.includes("-driver__in_office")), string]
        } else {
            let index = order.indexOf(string)
            if (order.indexOf(string) > -1) {
                order[index] = "-" + string
            } else {
                index = order.indexOf("-" + string)
                index > -1 && (order[index] = string)
            }
        }
        this.setState({ filterValues: { ...this.state.filterValues, orderBy: order } })
    }
    render() {
        return (
            <div className="ReservationsListContainer">
                <Container fluid>
                    <ReservationsListHeader
                        activeTab="inactive"
                        filterValues={this.state.filterValues}
                        setFilterValues={(filterValues) => this.setState({ filterValues })}
                        selectedDrivers={this.state.selectedDrivers} history={this.props.navigate} location={this.props.location}
                        resetSelectedDrivers={() => this.setState({ selectedDrivers: [] })}
                        refetchQuery={() => this.setState({ refetchReservations: !this.state.refetchReservations })}
                        presets={this.state.presets}
                        setPresets={this.setPresets}
                        defaultPresets={this.state.defaultPresets}
                    />
                    <Row>
                        <Col>
                            <ReservationsList
                                currentUser={this.props.currentUser}
                                orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                                updateOrder={this.updateOrder}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                selectedTab={"inactive"}
                                presets={this.state.presets}
                                selectedDrivers={this.state.selectedDrivers}
                                setSelectedDrivers={(selectedDrivers) => this.setState({ selectedDrivers })}
                                refetchReservations={this.state.refetchReservations}
                                setRefetchQuery={() => this.setState({ refetchReservations: !this.state.refetchReservations })}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}


//-----------------------------------
export default graphql(RepsQuery, {
    options: ({ groups }) => ({ variables: { groups: ["Front Office"] } }),
    props: ({ data: { allReps } }) => ({ allReps }),
})(
    graphql(AllCarLocations, {
        props: ({ data: { allCarLocations } }) => ({ allCarLocations }),
    })(
        graphql(AllRideSharingPartners, {
            props: ({ data: { allRideSharingPartners } }) => ({ allRideSharingPartners }),
        })(
            graphql(AllAgreementTypes, {
                props: ({ data: { allAgreementTypes } }) => ({ allAgreementTypes }),
            })(
                graphql(AllBrokers, {
                    props: ({ data: { allBrokers } }) => ({ allBrokers }),
                })(
                    withApolloClient(InactiveReservationsListContainer)
                )
            )
        )
    )
);

